import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'swiper/css';


function KeyFeatures() {
    const [currentIndex, setCurrentIndex] = useState(1)
    const handleFeatursIndex = (index) => setCurrentIndex(index)

    return (
        <>
            <section className='landing_page_main'>
                <section className='cms_page_top_section'>
                    <div className='page_title_section'>
                        <h1>Key Features</h1>
                        <div className='breadcrumb_section'>
                            <ul class="breadcrumb">
                                <li><Link to="/">Home</Link></li>
                                <li> Key Features</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section className='cms_content_section'>
                    <div className='container'>
                        <h3>Weekly & Bi-Weekly Paycheck Compatibility</h3>
                         <h1>Designed for your pay schedule.</h1>
                        <p>Unlike other budgeting apps, BYP is built specifically for individuals who are paid weekly or bi-weekly. The app automatically accounts for the number of paychecks you’ll receive in a year and adjusts your budget accordingly. This makes it the perfect tool for anyone managing their money paycheck-to-paycheck.
                        </p>

                        <div className='mt-70'>
                            <h3>Recommended Personal Allowance </h3>
                            <h1>Spend guilt-free with a personalized allowance!</h1>
                            <p>BYP calculates your personal allowance based on your income and expenses, giving you a specific amount to spend per paycheck.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>Expense Tracker</h3>
                            <h1>Stay on top of your bills, every paycheck.</h1>
                            <p>See all your upcoming expenses for the current pay period in one convenient dashboard. Never miss a payment again! </p>
                        </div>

                        <div className='mt-70'>
                            <h3>Savings Forecast</h3>
                            <h1>Visualize your savings growth over time.</h1>
                            <p>
                            Track how your savings will accumulate over the next 12 months! BYP shows you exactly how much you’ll save each paycheck and provides a clear, month-by-month savings projection.
                            </p>
                        </div>

                        <div className='mt-70'>
                            <h3>Dynamic Goal Planning</h3>
                            <h1>Plan for life’s big expenses effortlessly.</h1>
                            <p>
                            Anticipating a major one-time expense? BYP helps you set goals for future expenses like vacations, holiday shopping, or medical bills. The app calculates how much you’ll need to save each paycheck to meet your goal by your desired deadline, and it tracks your progress as you make payments toward it.
                            </p>
                        </div>

                        <div className='mt-70'>
                            <h3>Split Expenses</h3>
                            <h1>Break down large expenses into smaller payments.</h1>
                            <p>No more worrying about large, one-time payments throwing off your budget. BYP allows you to split big expenses into smaller, manageable payments across multiple pay periods. This feature ensures you stay within your budget while meeting your obligations.
                            </p>
                        </div>

                    </div>
                </section>
                <section id='download-app' className='download_app_section section'>
                    <div className='container'>
                        <div className='download_section'>
                            <div className='download_box'>
                                <h2 className='font-52'>Download from the Apple & Google Play Store</h2>
                                <p className='font-20'>Ready to manage your money between paychecks? Download BYP now from the App Store or Google Play! Whether you’re an iOS or Android user, your journey to financial freedom is just a click away.
                                </p>
                                <div className='download_button_play'>
                                    <a className='app_store_btn' href='https://apps.apple.com/app/id6738954470' target='_blank' rel='noopener noreferrer'><img src="/images/app_store.svg" alt="Download on the App Store" /></a>
<a className='app_store_btn' href='https://play.google.com/store/apps/details?id=com.budget_bible.android&pcampaignid=web_share' target='_blank' rel='noopener noreferrer'><img src="/images/google_play.svg" alt="Get it on Google Play" /></a>
                                </div>
                            </div>
                            <div className='download_box_tow'>
                                <div className='image_left_download'>
                                    <img src="/images/byp-download-app-mockup.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="contact-us" className="contact_section section">
                    <div className='container'>
                        <div className='contact_content'>
                            <h2 className='font-52'>Contact Us</h2>
                            <p className='font-20'>Have Questions? We’re Here to Help!</p>

                            <div className='contact_form'>
                                <div className='row g-5'>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='First Name' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Last Name' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Email Address' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Phone Number' />
                                    </div>
                                    <div className='col-12'>
                                        <textarea id="txtid" name="txtname" rows="4" cols="50" maxlength="200" className='contact_input text_area' placeholder='Write a message'></textarea>
                                    </div>
                                    <div className='col-12'>
                                        <button type='button' className='btn submit_btn'>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default KeyFeatures;
